import axios from "axios";
import { BaseUrl } from "../../Environment";
import { getSecureItem } from "../../utilsFunctions";

const token = getSecureItem("token");

// ─────────────────────────────────────────────
// Add Holiday (Single or Bulk)
// ─────────────────────────────────────────────
export const addHolidaysApi = async (data) => {
  try {
    const response = await axios.post(`${BaseUrl}/holiday/addHolidays`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error("addHolidaysApi Error:", error);
    return error.response;
  }
};

// ─────────────────────────────────────────────
// Get Holidays
// ─────────────────────────────────────────────
export const getHolidaysApi = async (companyId) => {
  try {
    const response = await axios.get(
      `${BaseUrl}/holiday/getHolidays/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("getHolidaysApi Error:", error);
  }
};

// ─────────────────────────────────────────────
// Update Holiday
// ─────────────────────────────────────────────
export const updateHolidaysApi = async (holidayId, data) => {
  try {
    const response = await axios.put(
      `${BaseUrl}/holiday/updateHolidays/${holidayId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("updateHolidaysApi Error:", error);
    return error.response;
  }
};

// ─────────────────────────────────────────────
// Delete Holiday
// ─────────────────────────────────────────────
export const deleteHolidaysApi = async (holidayId) => {
  try {
    const response = await axios.delete(
      `${BaseUrl}/holiday/deleteHolidays/${holidayId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("deleteHolidaysApi Error:", error);
  }
};
